import SendIcon from "@mui/icons-material/Send";
import { Button, IconButton, TextField } from "@mui/material";
import React from "react";

import { Comment } from "../../../generated/gql/graphql";
import useAssetCommentMutation from "../../../hooks/mutation/comments/use-asset-comment-mutation";

interface ReplyCommentProps {
  comment: Comment;
}

export function ReplyComment(props: ReplyCommentProps): React.ReactElement {
  const { comment } = props;

  const [isOpen, setIsOpen] = React.useState(false);
  const commentRef = React.useRef<HTMLInputElement>();

  const { createComment } = useAssetCommentMutation();

  const handleReplayComment = async (): Promise<void> => {
    if (!commentRef.current?.value || !comment.assetId) {
      return;
    }

    try {
      await createComment({
        assetId: comment.assetId,
        comment: commentRef.current.value,
        parentId: comment.id,
      });
    } catch (err) {
      console.error(err);
    }

    commentRef.current.value = "";
    setIsOpen(false);
  };

  return (
    <div className="mb-5">
      <Button onClick={() => setIsOpen(!isOpen)} size="small">
        Reply
      </Button>
      {isOpen && (
        <div className="flex mt-5">
          <TextField
            inputRef={commentRef}
            size="small"
            focused
            autoFocus
            label="Your comment"
            placeholder="Type something here…"
            className="w-full mr-5"
          />
          <IconButton onClick={() => handleReplayComment()} size="medium">
            <SendIcon fontSize="inherit" />
          </IconButton>
        </div>
      )}
    </div>
  );
}
